import React from "react";
import type { U3141ChildLotChain } from "../../../U3141Service";
import { U3141ChildLotChainDocumentsPanel } from "./U3141ChildLotChainDocumentsPanel";

export interface U3141ChildLotChainDocumentsTabProps {
  masterLotChainId: string;
  childLotChainId: string;
  /** Données du child lot chain (pour projet courant et liste initiale depuis lotDetail.documents). */
  childLotChain: U3141ChildLotChain | null;
  /** Callback après ajout/suppression pour rafraîchir le formulaire parent. */
  onDocumentsChange?: () => void;
  /** Désactive les boutons Ajouter document et Supprimer lorsque le formulaire child est en mode édition. */
  disableDocumentActions?: boolean;
}

export const U3141ChildLotChainDocumentsTab: React.FC<U3141ChildLotChainDocumentsTabProps> = (props) => {
  return <U3141ChildLotChainDocumentsPanel {...props} />;
};
